export const data = [
	{
		id: 1,
		title: "Advisory Services",
		items: [
			{ id: 1, label: "Strategy - Development, Review and Monitoring" },
			{ id: 2, label: "Sustainability and Responsible Leadership" },
			{ id: 3, label: "Business Process and Digital Transformation" },
			{ id: 4, label: "Human Resource Management and Culture" },
			{ id: 5, label: "Organizational Design and Review " },
			{ id: 6, label: "Tax Advisory" },
			{ id: 7, label: "Enterprise Risk Management" },
		],
	},
	{
		id: 2,
		title: "Training and Capacity Building",
		items: [
			{ id: 1, label: "Strategy Development" },
			{ id: 2, label: "Sustainability and Leadership" },
			{ id: 3, label: "Business Process Management" },
			{ id: 4, label: "Project Management" },
			{ id: 5, label: "Risk Management" },
		],
	},
	{
		id: 3,
		title: "Technology and  Software solutions",
		items: [
			{ id: 1, label: "Strategy Execution Solutions" },
			{ id: 2, label: "Business Process Management Solutions" },
		],
	},
];
